module.exports = __webpack_public_path__ + "img/logo_login_blk.f1caada7.png";